export const CommentTypes = {
    Accepted: 'accepted',
    Declined: 'declined',
    Noted: 'noted',
};
